<app-profile-header></app-profile-header>
<mat-dialog-content>
  <app-profile-modal-entries [entries]="entries" type="residence">
  </app-profile-modal-entries>
</mat-dialog-content>
<app-notification variant="warning"
  ><p class="be-body-s text-navy-800">
  Please make sure this information is correct.
</p></app-notification
>
<mat-dialog-actions class="be-btn-group be-btn-group--right">
  @if (submissionError) {
    <app-notification variant="error" class="block my-3">
      <p class="m-0">Couldn't update residence.</p>
    </app-notification>
  }
  <app-profile-confirmation-footer
    [isSubmitted]="isSubmitted"
    [isSubmitting]="isSubmitting"
    (onConfirm)="updateResidence()"
    (onCancel)="onCancel()"
  ></app-profile-confirmation-footer>

  @if (isSubmitted) {
    <app-notification variant="success" class="block mt-1">
      <p class="m-0">Residence successfully updated!</p>
    </app-notification>
  }
</mat-dialog-actions>
